export const TABS = 'Tabs';
